import React, { useEffect, useRef, useState } from "react";
import SchoolIcon from "@material-ui/icons/School";
import PeopleIcon from "@material-ui/icons/People";
import EmojiPeopleIcon from "@material-ui/icons/EmojiPeople";
import FavoriteIcon from "@material-ui/icons/Favorite";
import "./HomeSections.css";

const SCHOOLS = [
  "Future Leaders School",
  "Discovery Learning Center",
  "Harmony Montessori",
  "Bright Minds School",
  "New Horizon School",
  "Little Stars Academy",
  "Royal Oak International Montessori",
  "Arunodaya Montessori School",
  "Floreo Montessori",
  "Focus High School",
  "Montessori House of Children",
];

const STATS = [
  { label: "Schools served", target: 15, suffix: "+", icon: SchoolIcon },
  { label: "Active students", target: 1000, suffix: "", icon: PeopleIcon },
  { label: "Teachers", target: 100, suffix: "", icon: EmojiPeopleIcon },
  { label: "Satisfaction", target: 100, suffix: "%", icon: FavoriteIcon },
];

const AnimatedStatValue = ({ target, suffix = "", duration = 1800 }) => {
  const ref = useRef(null);
  const started = useRef(false);
  const [display, setDisplay] = useState(0);
  const [active, setActive] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;

    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      setDisplay(target);
      return undefined;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !started.current) {
          started.current = true;
          setActive(true);
          observer.disconnect();
        }
      },
      { threshold: 0.35 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, [target]);

  useEffect(() => {
    if (!active) return undefined;
    let startTime;
    let rafId;
    const tick = (timestamp) => {
      if (!startTime) startTime = timestamp;
      const progress = Math.min((timestamp - startTime) / duration, 1);
      setDisplay(Math.round((1 - (1 - progress) ** 3) * target));
      if (progress < 1) rafId = requestAnimationFrame(tick);
    };
    rafId = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(rafId);
  }, [active, target, duration]);

  return (
    <p ref={ref} className="cm__stat-value">
      {display.toLocaleString()}
      {suffix}
    </p>
  );
};

// Big-number strip on top, schools as a quiet text ticker below.
const ClientsSection = () => {
  const ticker = [...SCHOOLS, ...SCHOOLS];

  return (
    <section className="hs" aria-labelledby="community-title">
      <div className="hs__inner">
        <header className="hs__header">
          <p className="hs__eyebrow">Growing together</p>
          <h2 className="hs__title" id="community-title">Our Montestory community</h2>
          <p className="hs__lead">Trusted by leading Montessori schools worldwide.</p>
        </header>

        <div className="cm__stats">
          {STATS.map(({ label, target, suffix, icon: Icon }) => (
            <div className="cm__stat" key={label}>
              <span className="cm__stat-icon" aria-hidden>
                <Icon />
              </span>
              <AnimatedStatValue target={target} suffix={suffix} />
              <p className="cm__stat-label">{label}</p>
            </div>
          ))}
        </div>

        <p className="cm__ticker-label">Schools using Montestory</p>
        <div className="cm__ticker">
          <div className="cm__track">
            {ticker.map((name, index) => (
              <span
                className="cm__name"
                key={`${name}-${index}`}
                aria-hidden={index >= SCHOOLS.length}
              >
                {name}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ClientsSection;
